(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6441],{

/***/ 66188:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/[id]/[slug]",
      function () {
        return __webpack_require__(73349);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 73349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ ShopSingle; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var components_seo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84169);
/* harmony import */ var containers_storeContainer_storeContainer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41504);
/* harmony import */ var containers_shopHeader_shopHeader__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72363);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88767);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var services_product__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(32837);
/* harmony import */ var hooks_useRedux__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(34349);
/* harmony import */ var redux_slices_currency__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(64698);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(22120);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var utils_getImage__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(95785);
/* harmony import */ var components_shop_products_shop_products__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(56685);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(61730);
// pages/shop/[id]/[slug].tsx














// import brandService from "services/brand";


const ShopHorizontalCategories = next_dynamic__WEBPACK_IMPORTED_MODULE_12___default()(()=>Promise.all(/* import() */[__webpack_require__.e(719), __webpack_require__.e(2548)]).then(__webpack_require__.bind(__webpack_require__, 42548)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(42548)
            ]
    }
});
const PageLoading = next_dynamic__WEBPACK_IMPORTED_MODULE_12___default()(()=>__webpack_require__.e(/* import() */ 3595).then(__webpack_require__.bind(__webpack_require__, 3595)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(3595)
            ]
    }
});
var __N_SSP = true;
function ShopSingle(param) {
    let { memberState , shopData , canonicalUrl  } = param;
    var ref, ref1;
    const isDesktop = (0,_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)("(min-width: 1140px)");
    const { i18n , t  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_11__/* .useTranslation */ .$G)();
    const locale = i18n.language;
    const { query  } = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    const shopId = Number(query.id);
    const currency = (0,hooks_useRedux__WEBPACK_IMPORTED_MODULE_9__/* .useAppSelector */ .C)(redux_slices_currency__WEBPACK_IMPORTED_MODULE_10__/* .selectCurrency */ .j);
    // 👉 per lo shop NON usiamo più useQuery: abbiamo già shopData da SSR
    // prodotti del negozio
    const { data: products , isLoading: isProductsLoading  } = (0,react_query__WEBPACK_IMPORTED_MODULE_6__.useQuery)({
        queryKey: [
            "products",
            shopId,
            currency === null || currency === void 0 ? void 0 : currency.id,
            locale
        ],
        queryFn: ()=>{
            const params = {
                currency_id: currency === null || currency === void 0 ? void 0 : currency.id
            };
            return services_product__WEBPACK_IMPORTED_MODULE_8__/* ["default"].getAllShopProducts */ .Z.getAllShopProducts(shopId, params);
        },
        staleTime: 0,
        enabled: !!shopId
    });
    const extractedCategories = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        var ref, ref1, ref2, ref3;
        const categories = (products === null || products === void 0 ? void 0 : (ref = products.data) === null || ref === void 0 ? void 0 : (ref1 = ref.all) === null || ref1 === void 0 ? void 0 : ref1.reduce((acc, item)=>{
            var ref, ref1;
            if (Array.isArray(item === null || item === void 0 ? void 0 : item.products) && (item === null || item === void 0 ? void 0 : (ref = item.products) === null || ref === void 0 ? void 0 : ref.length)) {
                acc.push(item);
            }
            if (Array.isArray(item === null || item === void 0 ? void 0 : item.children) && (item === null || item === void 0 ? void 0 : (ref1 = item.children) === null || ref1 === void 0 ? void 0 : ref1.length)) {
                acc.push(...item === null || item === void 0 ? void 0 : item.children);
            }
            return acc;
        }, [])) || [];
        if (products === null || products === void 0 ? void 0 : (ref2 = products.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.recommended) === null || ref3 === void 0 ? void 0 : ref3.length) {
            return [
                {
                    uuid: "popular",
                    translation: {
                        title: t("popular")
                    },
                    id: 0
                },
                ...categories
            ];
        }
        return categories;
    }, [
        products === null || products === void 0 ? void 0 : products.data,
        t
    ]);
    // --- SEO & JSON-LD -------------------------------------------------------
    const shop = shopData || {};
    var ref2, ref3;
    const shopTitle = (ref3 = (ref2 = shop === null || shop === void 0 ? void 0 : (ref = shop.translation) === null || ref === void 0 ? void 0 : ref.title) !== null && ref2 !== void 0 ? ref2 : shop === null || shop === void 0 ? void 0 : shop.name) !== null && ref3 !== void 0 ? ref3 : "Gloco";
    var ref4;
    const shopDescription = (ref4 = shop === null || shop === void 0 ? void 0 : (ref1 = shop.translation) === null || ref1 === void 0 ? void 0 : ref1.description) !== null && ref4 !== void 0 ? ref4 : "Il 1\xb0 Marketplace digitale locale, scopri i Negozi della tua citt\xe0";
    const shopImage = (0,utils_getImage__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(shop === null || shop === void 0 ? void 0 : shop.logo_img) || "";
    var ref5, ref6, ref7;
    // 🔎 proviamo a ricavare una stringa di indirizzo dal negozio
    const shopAddressText = (ref7 = (ref6 = (ref5 = shop === null || shop === void 0 ? void 0 : shop.address_text) !== null && ref5 !== void 0 ? ref5 : shop === null || shop === void 0 ? void 0 : shop.address) !== null && ref6 !== void 0 ? ref6 : shop === null || shop === void 0 ? void 0 : shop.location) !== null && ref7 !== void 0 ? ref7 : "";
    // JSON-LD LocalBusiness (base, ora con indirizzo se disponibile)
    const jsonLd = {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        name: shopTitle,
        description: shopDescription,
        url: canonicalUrl
    };
    if (shopImage) {
        jsonLd.image = shopImage;
    }
    if (shop === null || shop === void 0 ? void 0 : shop.phone) {
        jsonLd.telephone = shop.phone;
    }
    // ✅ aggiunta ADDRESS: viene inserito solo se abbiamo almeno una stringa
    if (shopAddressText) {
        jsonLd.address = {
            "@type": "PostalAddress",
            streetAddress: shopAddressText,
            addressCountry: "IT"
        };
    }
    // ------------------------------------------------------------------------
    // se per qualche motivo non abbiamo i dati shop, mostriamo loader
    if (!shop || !shop.id) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PageLoading, {});
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_seo__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                title: shopTitle,
                description: shopDescription,
                image: shopImage
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: canonicalUrl
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                        type: "application/ld+json",
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify(jsonLd)
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(containers_storeContainer_storeContainer__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                data: shop,
                memberState: memberState,
                categories: extractedCategories,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(containers_shopHeader_shopHeader__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        loading: false
                    }),
                    !isDesktop && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ShopHorizontalCategories, {
                        categories: extractedCategories
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_shop_products_shop_products__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                        products: products === null || products === void 0 ? void 0 : products.data,
                        isLoading: isProductsLoading
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 95785:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getImage; }
/* harmony export */ });
// import { IMAGE_URL } from "constants/constants";
function getImage(img) {
    if (img) {
        return img;
    } else {
        return "";
    }
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9526,6072,9774,2888,179], function() { return __webpack_exec__(66188); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);